import React from 'react';

import { intercomDirectoryQrRoute as route } from 'routes/constants';

const RouteComponent = React.lazy(() => import('./IntercomDirectoryQrPage'));

export default {
  RouteComponent,
  path: route,
};
